module.exports = __webpack_public_path__ + "static/media/bat.24ec2550.svg";